const data = [
  {
    companyName: 'Devxhub',
    companyUrl: 'https://devxhub.com/',
    role: 'Frontend Engineer, Full Time - Remote',
    periods: 'July 2023 - Present',
    descriptions: [
      'Led a collaborative project with a Google Partner Engineer to develop an advanced internal stock exchange administration console using Google Cloud SDK (gcloud). This initiative involved implementing detailed industry and company relationship mapping, supplier and consumer lists, and hierarchical industry visualizations.',
      'Architected and developed an automated Parking Management System, streamlining real-time parking operations and visualizing data with ChartJS.',
      'Engineered secure authentication flows, data handling, and token storage solutions for client-side applications, ensuring compliance with security best practices.',
      'Collaborated closely with designers to translate UI/UX designs into functional and intuitive interfaces, achieving a 5% reduction in bounce rate and positive user feedback.',
      'Enhanced team efficiency by establishing frontend development best practices through code reviews and technical discussions, resulting in a 20% reduction in bug reports.'
    ],
    projects: [''],
    projectsName: ['']
  },
  {
    companyName: 'Nexuses',
    companyUrl: 'https://nexuses.io/',
    role: 'Frontend Engineer, Contract - Remote',
    periods: 'May 2023 - June 2023',
    descriptions: [
      'Improved the performance, readability, and maintainability of a legacy medical patient management system by refactoring class components into functional components, achieving a 30% reduction in code complexity and a 10% reduction in page load time.',
      'Enhanced UI consistency across devices by implementing styled-components for responsive design.',
      'Optimized routing and boosted overall system performance by upgrading the Next.js framework from version 12 to 13, utilizing SSR (Server-Side Rendering) and CSR (Client-Side Rendering) techniques.'
    ],
    projects: ['https://nexuses.io/'],
    projectsName: ['Nexuses']
  },
  {
    companyName: 'C-Sunshine',
    companyUrl: 'https://www.c-sunshine.com/',
    role: 'Frontend Engineer, Contract - Remote',
    periods: 'August 2022 - February 2023',
    descriptions: [
      'Developed and delivered new features for client projects using React.js, Redux, TypeScript, and Tailwind CSS, consistently meeting project deadlines and exceeding client expectations.',
      'Optimized code for performance and scalability, proactively addressing client requests and ensuring a seamless userexperience.'
    ],
    projects: [''],
    projectsName: ['']
  },
  {
    companyName: 'Brillmark LLC',
    companyUrl: 'https://www.brillmark.com/',
    role: 'Frontend Developer, Full Time - Remote',
    periods: 'April 2021 - May 2022',
    descriptions: [
      'Significantly improved over 100 websites with A/B testing methodologies, result 30% improvement in user engagement and providing data-driven insights for design optimization.',
      'Implemented custom front-end solutions utilizing Vanilla JS, SASS, and jQuery to deliver high-performance user experiences, demonstrably increasing conversion rates by 15% and contributing directly to revenue growth.',
      'Developed pixel-perfect, and fully responsive user interfaces by translating Figma and Adobe XD mockups with precision, ensuring seamless user experiences across all devices through effective use of CSS, SASS, and Bootstrap.',
      'Mentored and trained interns developers through dedicated mentorship and training, fostering their professional development and promoting a culture of knowledge sharing and coding best practices.'
    ],
    projects: ['https://www.skechers.com/', 'https://americanaddictioncenters.org/', 'https://www.springboard.com/'],
    projectsName: ['Skechers', 'American Addiction Centers', 'Springboard']
  }
];

export function experiencesData() {
  return data;
}
